'use client';
import React, { memo, useCallback, useMemo, useState } from 'react';

import { ITypo } from '@/app/_components/common';
import { Wrapper } from '@/app/_components/layout';
import { useGetCoursesQuery } from '@/store/api/course.api';
import { getQueryString, map } from '@/utils';

import CourseCard from './CourseCard';
import CourseItem from './CourseItem';

const CourseSection = () => {
	const { data } = useGetCoursesQuery(getQueryString({ populate: 'image' }));
	const courses = useMemo(() => data?.data || [], [data]);
	const [selectedCourse, setSelectedCourse] = useState<any>(null);
	const [key, setKey] = useState(0);

	const handleSelectCourse = useCallback((item: any) => {
		setSelectedCourse(item);
		setKey((prev) => prev + 1);
	}, []);
	return (
		<div className="mt-6 lg:pb-[100px]">
			<Wrapper className="col gap-2 p-0 text-center sm:p-0 lg:max-w-[726px] lg:p-0">
				<ITypo
					size={16}
					weight="semi"
					className="sm:text-24 text-center"
				>
					Các chương trình
				</ITypo>
				<ITypo
					size={20}
					weight="semi"
					className="sm:text-40 text-bittersweet text-center"
				>
					CÁ NHÂN HÓA CHUYÊN SÂU
				</ITypo>
				<ITypo size={14} className="sm:text-16 px-3">
					DLA thiết kế đa dạng các khoá học phù hợp riêng cho từng học
					viên theo mô hình cá nhân hoá phụ thuộc vào khả năng và mục
					tiêu của người học.
				</ITypo>
			</Wrapper>

			<Wrapper className="lg:row px-0 pb-0 pt-10 lg:gap-10 lg:pb-0 lg:pt-10 ">
				<div className="row lg:col gap-3 pb-6 first:*:ml-3 last:*:pr-3 max-lg:overflow-auto lg:gap-6 lg:first:*:ml-0 lg:last:*:pr-0">
					{map(courses, (item: any, idx: number) => {
						const isSelected =
							item?.documentId ===
							(selectedCourse?.documentId ||
								courses?.[0]?.documentId);
						return (
							<CourseItem
								key={idx}
								isSelected={isSelected}
								item={item}
								handleSelectCourse={handleSelectCourse}
							/>
						);
					})}
				</div>

				<div className="px-3 pb-5 pt-0 sm:pt-0" data-aos="fade-left">
					<div
						key={key}
						className="animate__animated animate__slideInRight animate__faster"
					>
						<CourseCard item={selectedCourse || courses?.[0]} />
					</div>
				</div>
			</Wrapper>
		</div>
	);
};

export default memo(CourseSection);
